import { Component, Inject, input, linkedSignal, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule, Modal, ResolvableModal } from '@softline/ui-core';
import {
  ArtikelInfoModalParams,
  SOFTLINE_CONFIG_ARTIKEL_INFO_MODAL_COMPONENT,
} from '@softapps/wws/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'soft-artikel-info',
  imports: [CommonModule, I18nModule],
  templateUrl: './artikel-info.component.html',
  styleUrls: ['./artikel-info.component.scss'],
})
export class ArtikelInfoComponent<T extends object>
  extends ResolvableModal<void>
  implements OnInit, OnDestroy, Modal<void>
{
  private subscription?: Subscription;

  id$!: Observable<number>;
  params!: ArtikelInfoModalParams<T>;
  close!: (_: void) => void;

  id = input<number>();
  options = input<ArtikelInfoModalParams<T>>();

  // inputs: Record<string, unknown> = {};

  readonly inputs = linkedSignal<Record<string, unknown>>(() => {
    const options = this.options();
    const id = this.id();
    if (!id) return {};

    return {
      id,
      params: options?.data ?? {},
    };
  });

  constructor(
    @Inject(SOFTLINE_CONFIG_ARTIKEL_INFO_MODAL_COMPONENT) readonly modalComponent
  ) {
    super();
  }

  registerCloseHandler(handler: (result: void) => void) {
    this.close = handler;
  }

  ngOnInit(): void {
    this.params?.onOpen?.();

    if (this.id$) {
      this.id$.subscribe((id) => {
        this.inputs.set({
          id,
          params: this.options()?.data ?? this.params?.data ?? {},
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.params?.onClose?.();

    if (this.subscription && !this.subscription.closed) this.subscription.unsubscribe();

    this.subscription = undefined;
  }
}
